import React from 'react';
import { Link } from 'react-router-dom';

const ToolTransparencyWidget = ({ affiliateLink }) => {
  const link = affiliateLink || {};
  const showPublic = link.show_commission_public !== false;
  const recurring = !!link.is_recurring;
  const tone = recurring
    ? { bg: 'rgba(57,255,20,0.10)', border: 'rgba(57,255,20,0.45)', accent: '#39FF14', label: 'Recurring commission' }
    : { bg: 'rgba(255,232,0,0.08)', border: 'rgba(255,232,0,0.45)', accent: '#FFE800', label: 'One-time CPA' };

  const publicStatement = `We earn ${link.commission || 'a commission'} if you purchase via our link. Cookie window: ${link.cookie_days || 'N/A'} days via ${link.network || 'direct'}.`;
  const genericStatement = link.disclosure_text_override || 'We may earn a commission if you purchase via our link. Some programs do not allow public disclosure of exact rates.';

  return (
    <div
      className="mt-4 p-4 border"
      style={{ background: tone.bg, borderColor: tone.border }}
      data-testid="tool-transparency-widget"
    >
      <div className="flex items-center justify-between gap-3 mb-2">
        <h4 className="text-sm font-semibold" style={{ color: tone.accent }}>
          Commission Transparency
        </h4>
        <span className="text-xs" style={{ color: tone.accent }}>
          {tone.label}
        </span>
      </div>

      <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
        {showPublic ? publicStatement : genericStatement}
      </p>

      <div className="mt-2 text-xs" style={{ color: 'var(--text-muted)' }}>
        <span
          title="What does this mean for you? Nothing — our recommendations are based on fit, not payout."
          style={{ cursor: 'help' }}
        >
          What does this mean for you?
        </span>
        {' '}Nothing - our recommendations are based on fit, not payout.
      </div>

      <Link to="/transparency" className="inline-flex mt-2 text-xs" style={{ color: 'var(--accent-primary)' }}>
        View full transparency table
      </Link>
    </div>
  );
};

export default ToolTransparencyWidget;
